<template>
    <div class="lg:w-full rounded border border-white mx-4 md:mx-0" :class="reservations.length ? '' : 'hidden md:block'">
        <div>
            <div class="">
                <div class="hidden md:block flex flex-col justify-start px-4 py-2 text-white text-lg">
                    <div class="flex flex-row items-center"><span class="w-24">Lediga tider</span> <div class="green-indicator-bar h-5 w-5 rounded-50 sm:h-1 sm:w-8 md:w-10 lg:w-12 xl:w-14 sm:rounded-none"></div></div>
                    <div class="flex flex-row items-center"><span class="w-24">Valda tider </span> <div class="blue-indicator-bar h-5 w-5 rounded-50 sm:h-1 sm:w-8 md:w-10 lg:w-12 xl:w-14 sm:rounded-none"></div></div>
                </div>
                <div v-if="reservations.length" class="px-4">
                    <div v-for="booking in reservations" class="flex flex-col mb-2 schedule-slot">
                        <hr class="text-white hidden md:block">
                        <div class="w-full flex flex-row justify-between mt-2">
                            <div class="flex flex-col text-sm text-white">
                                <div>Datum: {{getDate(booking.schedule.start, booking.schedule.end)}}</div>
                                <div>Tid: {{getTime(booking.schedule.start, booking.schedule.end)}}</div>
                                <div>Plats: {{booking.schedule.location.name}}</div>
                            </div>
                            <button type="button" v-on:click="removeReservation(booking.id)" class="flex flex-row items-center text-sm">
                                <img src="/images/large-cross.png" style="width: 32px; height: 32px">
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <button v-if="user_id && reservations.length" class="flex flex-row items-center btn bg-tlmblue2 m-4 mt-8 px-8 py-1 rounded text-white text-lg" v-on:click="emitPayment">Slutför <svg xmlns="http://www.w3.org/2000/svg" width="19.266" height="19.266" viewBox="0 0 19.266 19.266" fill="currentColor"><path class="b" d="M5.88,3.7l6.326,6.326L5.88,16.353l1.7,1.7,8.027-8.027L7.582,2Z" transform="translate(-1.16 -0.395)"/></svg></button>

        <div v-if="!user_id" class="p-4 text-white italic">Du måste logga in för att slutföra bokningen.</div>
    </div>
</template>

<script>
    export default {
        name: "reservations-new",
        props: ["user_id", 'company',  'consultant', 'reservations'],
        data() {
            return {
                baseURL: window.location.hostname + '/login',
            }
        },
        methods: {
            consultantQueryString () {
                let url = location.pathname.split('/');
                let last = url[url.length - 1];
                if (last == 'consultant') {
                    return '?consultant=1'
                }
                return '';
            },
            getDateTime(dateString, dateStringEnd){
                return moment(dateString).format('YYYY-MM-DD') + ' kl. ' + moment(dateString).format('HH:mm') + ' - ' + moment(dateStringEnd).format('HH:mm');
            },
            getDate(dateString, dateStringEnd){
                return moment(dateString).format('YYYY-MM-DD');
            },
            getTime(dateString, dateStringEnd){
                return moment(dateString).format('HH:mm') + ' - ' + moment(dateStringEnd).format('HH:mm');
            },
            getPrice(treatment){
                if(treatment.treatment_price){
                    if(this.consultant) {
                        return treatment.treatment_price.total_sum + ' kr';
                    }else {
                        return treatment.treatment_price.subv_total_sum + ' kr';
                    }
                }

                return 'Odefinierat pris';
            },
            getReservations() {
                let self = this;
                axios.get('/reservations?company_id='+this.company.id)
                    .then(response => {
                        self.reservations = response.data;
                    });
            },
            emitPayment() {
                this.$eventHub.$emit('showpayinfo');
            },
            emitReservationsDone() {
              this.$eventHub.$emit('reservationsDone');
            },
            removeReservations() {
                this.reservations = [];
            },
            removeReservation(id) {
                this.$emit('removeReservationWithId', id);
            },
            dateFormat: function (schedule) {
                return moment(schedule.start).format("YY-MM-DD") + " " + moment(schedule.start).format("HH:mm") + " - " + moment(schedule.end).format("HH:mm");
            },
            getLoginURL: function () {
                return window.location.hostname + '/login';
            }
        },
        computed: {},
        mounted() {
            this.$eventHub.$on('showpayinfo', function () {
            });
            this.getReservations();
        }
    }
</script>
<style scoped>
    .schedule-slot{
        display: flex;
        justify-content: space-between;
    }
    .green-indicator-bar {
        border: 2px solid rgb(41, 206, 30);
        background-color: rgb(41, 206, 30);
    }
    .blue-indicator-bar {
        border: 2px solid rgb(60, 79, 206);
        background-color: rgb(60, 79, 206);
    }
</style>
